import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import GymPage from './pages/GymPage';
import EventsPage from './pages/EventsPage';
import AmateurPage from './pages/AmateurPage';
import ContactPage from './pages/ContactPage';
import ShopPage from './pages/ShopPage';
import { Toaster } from './components/ui/sonner';
import { SHOP_ENABLED } from './config/site';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gym" element={<GymPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/amateur" element={<AmateurPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {SHOP_ENABLED && <Route path="/shop" element={<ShopPage />} />}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
